import {Button, Form} from "antd";
import {useTranslation} from "react-i18next";
export interface ResetProps{
    onReset:()=>void
}
export function Reset(props:ResetProps){
    const {t} = useTranslation();

    return <>
        <Form.Item >
            <Button htmlType="button" onClick={props.onReset}>
        {t("Pulisci")}
    </Button>
    </Form.Item>
    </>
}